// libs
// import "babel-polyfill";
import $ from "jquery";
import Vue from 'vue';
import VueRouter from 'vue-router';
import {breakpoint} from "./libs/Breakpoints";
import {truncate} from 'lodash';
import Rellax from 'rellax'
import Homepage from './libs/Homepage'
import ScrollMagicTaaf from './libs/ScrollMagicTaaf'
import Accordion from './libs/Accordion'
import ModalJob from './mixins/modalJob'
import Header from './mixins/header'
import Accessibility from './mixins/accessibility'
import Longpress from 'vue-long-press-directive';
import ShareSocial from './mixins/socialShare'
import Responsive from './mixins/responsive'
import ResponsiveLib from './libs/Responsive'

import CookieBanner from './libs/CookieBanner';
CookieBanner.init();

window.jQuery = $;
require('@fancyapps/fancybox');

// $('#app iframe').attr("v-pre", '')
Vue.filter('truncate', function (value, length = 40) {
    return truncate(value, {
        'length': length,
        'omission': '...'
    });
});

Vue.use(VueRouter);
Vue.use(Longpress, {duration: 1000});

const router = new VueRouter({
    mode: 'history',
});

// Vue Components
import './components';

// Vue.config.ignoredElements = ['style','svg'];
breakpoint.init();

$( "#app" ).after( $('#app script') );

export default new Vue({
    el: '#app',
    mixins:[ModalJob, Header,Responsive, Accessibility, ShareSocial],
    router,
    data: {
        siteLoaded:false,
        showMarianne:true
    },
    computed:{
    },
    methods: {
    },
    mounted() {
        this.siteLoaded = true
    },
});

$('.js-print').on('click', () => window.print() );

// Init Js
$(document).ready(() => {

    new Rellax('.rellax');
    Homepage.init()
    ScrollMagicTaaf.init()
    Accordion.init()
    ResponsiveLib.init()


    // Add body class if IE11
    if(navigator.userAgent.match(/Trident.*rv:11\./)) {
        $('body').addClass('ie11');
    }

});

